import { useEffect, useRef, useState } from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { useRouter } from "next/router";
import shareImg from "../../../../public/assets/images/share-icon.svg";
import linkImg from "../../../../public/assets/images/link.svg";

const SocialShare = () => {
  const pathname = useRouter();
  const [shareUrl, setShareUrl] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setShareUrl(window.location.href);
    }
  }, [pathname]);

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (even) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleUrl = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl); // Copy to clipboard
      console.log("URL Copied!");

      // Check if Web Share API is supported
      if (navigator.share) {
        await navigator.share({
          title: document.title,
          url: shareUrl,
        });
      }
    } catch (err) {
      console.log("Failed to copy or share URL." + err);
    }
  };

  const SocialIcons = ({ classNameData }) => {
    return (
      <div className={`social-cb ${classNameData}`}>
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>

        <LinkedinShareButton url={shareUrl}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>

        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>

        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>

        <EmailShareButton url={shareUrl}>
          <EmailIcon size={32} round />
        </EmailShareButton>

        <span
          title="Copy & Share URL"
          style={{
            backgroundColor: "#1677ff",
            verticalAlign: "middle",
            cursor: "pointer",
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            padding: "6px",
              display: "flex",
            cursor:"pointer"
          }}
          onClick={() => {
            handleUrl();
          }}
        >
          <img
            src={linkImg?.src}
            alt="Custom Link"
            style={{
              maxWidth: "100%",
            }}
          />
        </span>
      </div>
    );
  };

  return (
    <div className="social-m_cb" ref={ref}>
      {/* <span
        className={`share-btn ${open ? "active" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        Share
      </span> */}

      <span
        className={`share-btn-mob ${open ? "active" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <img
          src={shareImg?.src}
          alt="Share icon"
          style={{
            display: "block",
            maxWidth: "100%",
          }}
        />
      </span>

      <SocialIcons classNameData={open ? "active" : ""} />
    </div>
  );
};

export default SocialShare;
